import React, { useEffect } from 'react';
import { Row } from 'antd';
import { Link } from 'react-router-dom';
import { ERoutesPrivate } from 'common/models/routesModel';
import { ReactComponent as BackIcon } from 'app/assets/images/back.svg';
import { ReactComponent as HistoryIcon } from 'app/assets/images/bitecoinHistory.svg';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getBitecoinRewardCollectionByStoreId, getBitecoinRewardCollectionDefault } from 'app/store/reducers/bitecoin.reducer';
import { BitecoinWalletBalanceWidget } from 'entities/Bitecoin/components/BitecoinWalletBalanceWidget';
import { BitecoinRewardCategoriesPanel } from 'entities/Bitecoin/components/BitecoinRewardCategoriesPanel';
import { BitecoinRewardList } from 'entities/Bitecoin/components/BitecoinRewardList';

export const BitecoinPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { customerModel, customerModelLoading } = useAppSelector((state) => state.customer);

  useEffect(() => {
    const customerStoreId = customerModel?.store?.id;

    if (!customerModelLoading) {
      if (customerStoreId) {
        dispatch(getBitecoinRewardCollectionByStoreId(customerStoreId));
      } else {
        dispatch(getBitecoinRewardCollectionDefault());
      }
    }
  }, [customerModel, customerModelLoading]);

  return (
    <div>
      <div className="store-panel">
        <Row align="middle" justify="space-between" className="pt-6 pb-4 pl-7 pr-7 store-panel__container">
          <Row align="middle" onClick={() => history.go(-1)}>
            <BackIcon />
            <span className="fs-xs font-weight-7">Bitecoin Wallet</span>
          </Row>
          {/* Figma 14500:12436: history icon with an orange dot → Bitecoins history screen. */}
          <Link to={ERoutesPrivate.BitecoinHistory} className="bitecoin-wallet__history-link" title="Bitecoins History">
            <div className="bitecoin-wallet__history-link-icon">
              <HistoryIcon />
            </div>
            <span className="ml-3 fs-xs font-weight-7">Rewards History</span>
          </Link>
        </Row>
      </div>
      {/* Figma 14483:11827: the friend-code block is rendered inside the balance widget's brown card. */}
      <BitecoinWalletBalanceWidget />
      <BitecoinRewardCategoriesPanel />
      <BitecoinRewardList />
    </div>
  );
};
